// import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import '../../Client/ProfileEntreprise/CompteClient.scss';

import React from 'react';
import { useTranslation } from 'react-i18next';

import useWindowSize from '../../../hooks/useWindowSize';
import ProfilEntreprise from '../../Client/ProfileEntreprise/ProfilEntreprise';
import NewCompany from '../CompleterProfile/Step3_companyData/NewCompany';

function DonneesGenerales() {
    const {device}=useWindowSize();
    const { i18n } = useTranslation();
    return (
        <>
            <div style={{display:'flex',flexDirection:'column',alignItems: 'flex-start',alignSelf:'stretch',gap:'24px'}}>
                <div className='frame5Profile'>{i18n.t('Compte entreprise')} &gt; <span style={{color:'rgba(39, 45, 60, 1)'}}>{i18n.t('Profil entreprise')} </span> </div>
                <div style={{display:'flex',flexDirection:device=='desktop'?'row':'column',alignSelf:'stretch',gap:'24px'}}>
                    <ProfilEntreprise/>

                    <div style={{display:'flex',flexDirection:'column',justifyContent:'space-between',width:device=='desktop'?'80%':'100%',alignItems: 'center'}}>
                        <NewCompany action={'visualise'}/>
                    </div>
                </div>
            </div>
        </>
    );
}

export default DonneesGenerales;